module.exports = __webpack_public_path__ + "static/media/Group2.13c71c10.png";